import { BackTop } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import React from 'react';
import '../styles/Base.scss';

export default function NewsEvents() {
  const screen = useBreakpoint();

const events = [
  {
  date: 'Nov. 2025',
  img: 'assets/gai.png',
  desc: <>
    <strong>
      Talk by Joaquim Jorge: Generative Artificial Intelligence — Ethics and Impact in a People-Centred Future
    </strong>
    <br /><br />
    <strong>Objectives:</strong> To reflect on the main ethical challenges associated with Generative Artificial Intelligence; to identify ways to ensure that the development and deployment of AI are responsible and people-centred; to promote dialogue across different fields of knowledge on the impact of AI on society, work, and citizenship.
    <br /><br />
    <em>
     <strong> Panel:</strong> One moderator and two invited speakers (with Cláudia Lima Costa)
    </em>
    <br />

    <div style={{ marginTop: '2rem' }}>
      <iframe
      width="320"
      height="180"
      src="https://www.youtube.com/embed/sL3jneL3S-g?start=1178"
      title="Generative AI Ethics and Impact"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    ></iframe>
    </div>
  </>
}
,
  {
  date: 'Nov. 2025',
  img: 'assets/nov.png',
  desc: <>
    Presentation by Joaquim Jorge in the November to Remember series.
    <div style={{ marginTop: '2rem' }}>
      <iframe
        src="https://drive.google.com/file/d/1Uwqm_tYThNlLmqQzHYcdRvUWkU0EkT7i/preview"
        width="320"
        height="180"
        style={{ border: 0 }}
        allow="autoplay"
        allowFullScreen
        title="November to Remember Presentation"
      ></iframe>
    </div>
  </>
},


  {
    date: 'Aug. 2025',
    img: 'assets/azores.jpeg',
    desc: <>Participation of Joaquim Jorge in the UNESCO Chairs Meeting at the Universidade dos Açores, Ponta Delgada.</>
  },
  {
    date: 'July. 2025',
    img: 'assets/keynote.jpg',
    desc: <>Keynote talk by Joaquim Jorge at the Faculty of ICT, University of Malta. <a href='https://www.facebook.com/um.ictfaculty/videos/1440731713618568'>🎥 Watch the keynote starting at 3:57:20</a>.</>
  },
  {
    date: 'May. 2025',
    img: 'assets/ids.png',
    desc: <>Participation of Joaquim Jorge and Catarina Moreira in the organization of the <a href="https://academicdatascience.org/events/adsa-meetings/2025-international-ds-leadership-summit/">International Data Science Leadership Summit</a> held at the American University of Paris, France.</>
  },
  {
    date: 'Jan. 2025',
    img: 'assets/logoAIXVR.jpg',
    desc: <>Organizing the <a href="https://aixvr.tecnico.ulisboa.pt/">AIxVR Symposium</a> in Técnico Lisboa.</>
  },
  {
    date: 'Jan. 2025',
    img: 'assets/group.jpg',
    desc: <><a href='https://www.dagstuhl.de/25031'>Dagstuhl Seminar on Addressing Future Challenges of Telemedicine Applications</a>.</>
  },
  {
    date: 'Sep. 2024',
    img: 'assets/keynote.jpg',
    desc: <>Session at the United Nations Science Summit.</>
  },
  {
    date: 'July. 2024',
    img: 'assets/keynote.jpg',
    desc: <>Talk by Joaquim Jorge on distortions of perception at the Winter School on the Psychology of XR at the University of South Australia in Adelaide.</>
  },
  {
    date: 'July. 2024',
    img: 'assets/signed.png',
    desc: <>Data Science Institute at UTS Sydney joined the AI&VR Consortium.</>
  },
  {
    date: 'July. 2024',
    img: 'assets/signed.png',
    desc: <>Signing of the MoU between UNESCO Chairs on AI&XR and Digital Anatomy (France).</>
  },
  {
    date: 'Jan. 2024',
    img: 'assets/participation.png',
    desc: <>Catarina Moreira and Anderson Maciel participated in the organization of AIxVR 2024 in Los Angeles (Hybrid).</>
  },
  {
    date: 'Dec. 2023',
    img: 'assets/toward25.png',
    desc: <>AI and Extended Reality – Transforming Education Towards 2025. Vision and actions of the UNESCO Chairs. <a href='https://canal.uned.es/video/6582a0d4371fa0276d4f4c34?track_id=6582a169371fa02776694552'>🎥 Watch the recording</a>.</>
  },
  {
    date: 'Dec. 2023',
    img: 'assets/odd.png',
    desc: <>Participation of Joaquim Jorge in the <a href="https://www.uned.es/universidad/inicio.html">Conference of UNESCO Chairs on Open, Digital, and Distance Education</a>, organized by UNED, Spain.</>
  },
  {
    date: 'Nov. 2023',
    img: 'assets/keynote.jpg',
    desc: <>Presentation by Catarina Moreira and Joaquim Jorge on “Challenges and Opportunities for VR in Healthcare” at SIGGRAPH Asia 2023, Sydney.</>
  },
  {
    date: 'Aug. 2023',
    img: 'assets/keynote.jpg',
    desc: <>Workshop on AI&VR organized by W. Huerst and Joaquim Jorge at SIGGRAPH 2023.</>
  },
  {
    date: 'July. 2023',
    img: 'assets/keynote.jpg',
    desc: <>Presentation at the Summer School on AI&XR, Matera, Italy.</>
  },
  {
    date: 'Mar. 2023',
    img: 'assets/keynote.jpg',
    desc: <>Workshop on XR for Health co-located with IEEE VR 2023.</>
  },
  {
    date: 'Feb. 2023',
    img: 'assets/signed.png',
    desc: <>Launch of the Xavier Project with funding from the Portuguese Science Foundation (FCT).</>
  },
  {
    date: 'Jan. 2023',
    img: 'assets/signed.png',
    desc: <>Joining of Tsinghua University to the AI&VR Consortium.</>
  },
  {
    date: 'Nov. 2022',
    img: 'assets/signed.png',
    desc: <>Start of a joint project involving IST, UNCG, Clemson, and Duke Universities.</>
  },
  {
    date: 'Sep. 2022',
    img: 'assets/signed.png',
    desc: <>Approval and signing of the UNESCO Chair by the Rector of the University of Lisboa.</>
  },
];



  return (
    <div
      className="home-content"
      style={{
        marginLeft: screen.md ? '15%' : '0%',
    marginRight: screen.md ? '15%' : '0%',
    maxWidth: screen.md ? '70%' : '100%',
    padding: '2rem 1rem',
    transition: 'all 0.3s ease',
      }}
    >
      <BackTop />

      {/* UNESCO logo */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: '109px',
          height: '80px',
          marginRight: '20px',
          marginTop: '16px',
        }}
      >
        <img
          src="assets/unesco.png"
          alt="logo"
          style={{ width: '100%', height: '100%' }}
        />
      </div>

      {/* content wrapper for responsive padding */}
      <div className="content-wrap">
        <div className="home-title">
          <div className="title">News and Events</div>

          <div className="paragraph">
            {events.map((item, index) => (
              <div key={index} className="event-item">
                <img src={item.img} alt="icon" className="event-icon" />
                <div className="event-text">
                  <div className="event-date">{item.date}</div>
                  <div className="event-desc">{item.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}


